import videojs from 'video.js'
import $ from 'jquery';
import {gen,icon,isDefined,isMobile,isEmpty} from '../Helpers'
import Player  from '@vimeo/player';
import {EVENT_WINDOW_RESIZE,VIDEO_PLAYER_READY} from "../Paramaters";


export default class Video{
    constructor(props){
        this.$wrap =$(props.wrap);
        this.element = this.$wrap.find('.video_bg');
        this.element_id = this.element.attr('id');
        this.video_id = this.element.attr('data-videoid');
        this.desktop_img = this.$wrap.find('.desktop-img');
        this.mobile_img = this.$wrap.find('.mobile-img');
        this.autoPlay = isDefined(props.autoPlay) ? props.autoPlay : true;
        this.use_youtube = this.element.hasClass('youtube');
        this.use_vimeo = this.element.hasClass('vimeo');
        this.use_video = this.element.is('video');

        if(isMobile()){
            this.init_mobile();
            return;
        }
        if(!isEmpty(this.video_id)){
            this.init();
        }


    }


    init(){
        this.events();

        this.$wrap.hide()


        if(this.use_youtube){
            this.youtube_init();
        }
        if(this.use_vimeo){
            this.vimeo_init();
        }
        if(this.use_video){
            this.video_init()
        }



    }
    events(){
     $(document).one(VIDEO_PLAYER_READY,(e,data)=>this.onReady(data))
        $(window).on(EVENT_WINDOW_RESIZE,()=>this.onResize())

    }
    onReady(data){
        data.type === "youtube" ? this.player.playVideo() : this.player.play();
        this.desktop_img.addClass('hide');
        this.addStateButon()
        this.$wrap.fadeIn('fast')
    }


    onResize(){
        if(!isEmpty(this.player)){
            if(this.use_youtube){
                this.player.setSize(this.$wrap.width());
            }


        }
    }




    init_mobile(){
        this.element.hide();
        this.desktop_img.addClass('hide');
        this.mobile_img.removeClass('hide');

        //this.$wrap
    }

    addStateButon(){
        /*this.videoControl = gen('div',{
            'class':`video-toggle ${this.autoPlay ? 'is-play' : ''}`
        }).html([icon('play'),icon('puse')])
        this.videoControl.click(()=> this.toggleVideo())

        this.$wrap.append(this.stateBtn)*/

    }

    toggleVideo(){
        if (this.player.paused()) {
            this.stateBtn.addClass('is-play')
            this.player.play();
        }
        else {
            this.stateBtn.removeClass('is-play')
            this.player.pause();
        }

    }

    video_init(){
        this.player = videojs(this.element[0], {
            autoplay: this.autoPlay,
            controls : false,
            muted:true,
            loop:true
        });
        this.player.on('ready', (data)=>{
            $(document).trigger(VIDEO_PLAYER_READY,{type:'vimeo',data})
        });
    }

    youtube_init(){
        const tag = document.createElement('script');
        tag.src = "//www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);

    }
    vimeo_init(){
        this.player = new Player(this.element_id,{
            id:this.video_id,
            autoplay:true,
            width: this.$wrap.width(),
            loop: true,
            responsive:true,
        });

        this.player.on('loaded', function(data) {
            $(document).trigger(VIDEO_PLAYER_READY,{type:'vimeo',data})
        });

        this.player.on('ended', function(data) {
            $(document).trigger(VIDEO_ENDED,{type:'vimeo',data})
        });


        this.player.setVolume(0);
        this.player.play()

    }
    onYouTubeIframeAPIReady() {
        this.player = new YT.Player(this.element_id, {
           // height: this.$wrap.height(),
            width: this.$wrap.width(),
            videoId:this.video_id,
            playerVars: { 'autoplay': 1, 'controls': 0 ,'muted':1},
            events: {
                'onReady': (e)=>{this.onPlayerReady(e)},
                'onStateChange' : (e)=>{this.onStateChange(e)}
            }
        });

    }
    onPlayerReady() {
        this.player.mute();
        this.player.setPlaybackQuality('auto');
        $(document).trigger(VIDEO_PLAYER_READY,{type:'youtube'})
    }
    onStateChange(e){
        if (e.data === YT.PlayerState.ENDED) {
            this.player.playVideo();
        }
    }

}